<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
            <form #f="ngForm" name="form" novalidate>
                <div class="p-fluid p-formgrid grid mb-3">
                    <div class="field col-12 md:col-6">
                        <label>Descrição</label>
                        <input
                            name="descricao"
                            type="text"
                            pInputText
                            placeholder="Digite a descrição"
                            [(ngModel)]="patrimonio.descricao"
                            #descricao="ngModel"
                            required
                        />
                        <div *ngIf="descricao.hasError('required') && descricao.dirty">
                            <small>Campo obrigatório</small>
                        </div>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label>Grupo</label>
                        <input
                            name="grupo"
                            type="text"
                            pInputText
                            [(ngModel)]="patrimonio.grupo"
                            #grupo="ngModel"
                        />
                    </div>
                    <div class="field col-12 md:col-3">
                        <label>Marca/Modelo</label>
                        <input
                            name="marcaModelo"
                            type="text"
                            pInputText
                            [(ngModel)]="patrimonio.marcaModelo"
                            #marcaModelo="ngModel"
                        />
                    </div>
                    <div class="field col-12 md:col-3">
                        <label>Nº Série</label>
                        <input
                            name="numeroSerie"
                            type="text"
                            pInputText
                            [(ngModel)]="patrimonio.numeroSerie"
                            #numeroSerie="ngModel"
                        />
                    </div>

                    <div class="field col-12 md:col-3">
                        <label>Disposição Bem</label>
                        <input
                            name="disposicaoDoBem"
                            type="text"
                            pInputText
                            [(ngModel)]="patrimonio.disposicaoDoBem"
                            #disposicaoDoBem="ngModel"
                        />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label>Tombo</label>
                        <input
                            name="tombo"
                            type="text"
                            pInputText
                            [(ngModel)]="patrimonio.tombo"
                            #tombo="ngModel"
                        />
                    </div>

                    <div class="field col-12 md:col-2">
                        <label>Data Aq. Avaliação</label>
                        <p-calendar
                            [readonlyInput]="false"
                            [showIcon]="true"
                            dateFormat="dd/mm/yy"
                            [showButtonBar]="true"
                            placeholder="Selecione"
                            name="dataAquisicaoAvaliacao"
                            [(ngModel)]="patrimonio.dataAquisicaoAvaliacao"
                            #dataAquisicaoAvaliacao="ngModel"
                        ></p-calendar>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label>Valor Aq. Avaliação</label>
                        <p-inputNumber
                            mode="currency"
                            inputId="currency-brazil"
                            currency="BRL"
                            locale="pt-BR"
                            [allowEmpty]="true"
                            name="valorAquisicaoAvaliacao"
                            #valorAquisicaoAvaliacao="ngModel"
                            [(ngModel)]="patrimonio.valorAquisicaoAvaliacao"
                        ></p-inputNumber>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label>Valor Res. Descarte</label>
                        <p-inputNumber
                            mode="currency"
                            inputId="currency-brazil"
                            currency="BRL"
                            locale="pt-BR"
                            [allowEmpty]="true"
                            name="valorResidualDescarte"
                            #valorResidualDescarte="ngModel"
                            [(ngModel)]="patrimonio.valorResidualDescarte"
                        ></p-inputNumber>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label>Perc Res. Anual</label>
                        <p-inputNumber
                            suffix="%"
                            [max]="100"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [allowEmpty]="false"
                            name="percentualResidualAnual"
                            #percentualResidualAnual="ngModel"
                            [(ngModel)]="patrimonio.percentualResidualAnual"
                        ></p-inputNumber>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label>Vida útil (meses)</label>
                        <input
                            name="vidaUtilMeses"
                            type="text"
                            pInputText
                            [(ngModel)]="patrimonio.vidaUtilMeses"
                            #vidaUtilMeses="ngModel"
                        />
                    </div>
                    <div class="field col-12 md:col-3">
                        <label>Situação</label>
                        <p-dropdown
                            [options]="situcoesPatrimonio"
                            optionLabel="label"
                            placeholder="Selecione"
                            name="situcao"
                            #situacao="ngModel"
                            [(ngModel)]="patrimonio.situacao"
                        ></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label>Observações</label>
                        <input
                            name="observacoes"
                            type="text"
                            pInputText
                            [(ngModel)]="patrimonio.observacoes"
                            #observacoes="ngModel"
                        />
                    </div>
                </div>
                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div class="col-12 md:col-4">
                        <button
                            *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                            type="submit"
                            pButton
                            icon="pi pi-check"
                            label="Salvar"
                            class="p-button-outlined p-button-success md:w-9rem"
                            [disabled]="!f.valid"
                            (click)="salvar()"
                        ></button>
                        <ng-template #exibirBotaoFalso>
                            <button
                                type="submit"
                                pButton
                                icon="pi pi-spin pi-spinner"
                                label="Salvar"
                                class="p-button-outlined p-button-success md:w-9rem"
                                disabled
                            ></button>
                        </ng-template>
                    </div>
                    <div class="col-12 md:col-4 flex justify-content-end">
                        <button
                            type="button"
                            pButton
                            icon="pi pi-arrow-left"
                            label="Voltar"
                            class="p-button-outlined md:w-9rem"
                            routerLink="/apps/patrimonio"
                        ></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
